/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { TypographyComponent } from '@tvg/fuse-design';
import styled from 'styled-components';
import { FeatureBullet } from '../Shared/FeatureBullet';

const WhatsCovered = styled(TypographyComponent)`
  margin-bottom: 15px;
`;

const Description = styled(TypographyComponent)`
  margin-bottom: var(--spacing-space24);
`;

interface Props {
  description?: string;
  boldDescription?: string;
  dataTestId?: string;
  covered?: string[];
  notCovered?: string[];
  coverdTitle?: string;
  notCoveredTitle?: string;
  withDescription?: boolean;
}

export function InsuraceDescription({
  description,
  boldDescription,
  dataTestId = 'insurance-description',
  covered,
  notCovered,
  coverdTitle = 'What’s covered',
  notCoveredTitle = 'Not covered',
  withDescription = true,
}: Props) {
  return (
    <div data-testid={dataTestId}>
      {withDescription && (
        <Description size="m1" tag="p" type="paragraph">
          {`${description} `}
          <TypographyComponent size="m1" color="var(--color-global-black)" tag="span" type="heading">
            {boldDescription}
          </TypographyComponent>
        </Description>
      )}
      <WhatsCovered color="var(--color-global-black)" size={notCovered ? 'm1' : '1'} tag="p">
        <b>{coverdTitle}</b>
      </WhatsCovered>
      {covered?.map((coveredItem: string) => <FeatureBullet featureBullet={coveredItem} isCovered />)}
      {notCovered ? (
        <>
          <WhatsCovered color="var(--color-global-black)" size={notCovered ? 'm1' : '1'} tag="p">
            <b>{notCoveredTitle}</b>
          </WhatsCovered>
          {notCovered.map((notCoveredItem: string) => (
            <FeatureBullet featureBullet={notCoveredItem} isCovered={false} />
          ))}
        </>
      ) : null}
    </div>
  );
}

export default InsuraceDescription;
